import { create } from "zustand";
import { persist } from "zustand/middleware";

interface Address {
  address: string;
  address2?: string | undefined;
  state: string;
}

interface AddressStore {
  address: Address;
  setAddress: (address: Address) => void;
  resetAddress: () => void;
}

export const useAddressStore = create(
  persist<AddressStore>(
    (set) => ({
      address: {
        address: "",
        address2: "",
        state: "",
      },
      setAddress: (address) => set({ address }),
      resetAddress: () =>
        set({
          address: {
            address: "",
            address2: "",
            state: "",
          },
        }),
    }),

    { name: "createStoreAddress" }
  )
);
